import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { fieldTemplateService } from '../../../services/fieldTemplateService'
import { toast } from 'react-toastify'
import { FIELD_TYPES, TABLE_FIELD_CONSTRAINTS } from '../../../utility/constants'
import TableFieldConstraintItemEditUI from './TableFieldConstraintItemEditUI'

const TableFieldConstraintUI = ({ field, ftData, activityTemplateId, processTemplateId }) => {
  const { user } = useAuthContext()
  const [fields, setFields] = useState([])
  const [constraints, setConstraints] = useState([])
  const [pivotFields, setPivotFields] = useState([])
  const [tableField, setTableField] = useState(null)

  useEffect(() => {
    ;(async () => {
      if (user && activityTemplateId && processTemplateId) {
        const tableField = ftData.find((it) => {
          return (
            it.data_structure == FIELD_TYPES.TABLE &&
            it.subfield_template_ids.split(',').includes('' + field.id)
          )
        })
        setTableField(tableField)

        if (tableField) {
          const allFieldResult = (
            await fieldTemplateService.getSubfieldsOfTableField(user, tableField?.id)
          ).data

          setFields(
            allFieldResult.map((it) => ftData.find((ft) => ft.id == it.subfield_template_id)),
          )
        }

        const constraintResult = await fieldTemplateService.getTableConstraints(
          user,
          activityTemplateId,
        )
        const pivotFields = await fieldTemplateService.getAllPivotFieldsInProcess(
          user,
          processTemplateId,
        )

        const pureConstraints = constraintResult?.data
          ?.filter((it) => it.subfield_template_id == field.id)
          .map((it) => ({
            id: it.id,
            subfield_template_id: it.subfield_template_id,
            constraint: it.constraint,
            table_field_template_id: it.table_field_template_id,
            constant_value: it.constant_value,
            related_subfield_template_id: it.related_subfield_template_id,
            pivot_field_template_id: it.pivot_field_template_id,
          }))

        setConstraints(pureConstraints)
        setPivotFields(pivotFields?.data)
      }
    })()
  }, [ftData])

  const saveChanges = async () => {
    try {
      const sanitizedConstraints = constraints.map((it) => {
        const updated = {
          ...it,
        }

        // Unique
        if (it.constraint === TABLE_FIELD_CONSTRAINTS.UNIQUE) {
          delete updated.constant_value
          delete updated.related_subfield_template_id
        }

        // MIN_1_MATCH
        if (it.constraint === TABLE_FIELD_CONSTRAINTS.MIN_1_MATCH) {
          delete updated.pivot_field_template_id
          delete updated.related_subfield_template_id
        }

        return updated
      })

      // validation
      const invalidMinMatch = sanitizedConstraints.find(
        (it) => it.constraint === TABLE_FIELD_CONSTRAINTS.MIN_1_MATCH && !it.constant_value,
      )

      if (invalidMinMatch) {
        toast.error('Value is mandatory for MIN_1_MATCH')
        return
      }

      const updatedConstraints = await fieldTemplateService.addTableFieldConstraints(
        user,
        field.id,
        sanitizedConstraints,
      )

      setConstraints(updatedConstraints)

      toast.success('Added successfully')
    } catch (error) {
      toast.error('Error while adding conditional enabling/disabling')
    }
  }

  const addRow = () => {
    setConstraints([
      ...constraints,
      {
        id: new Date().getTime(),
        subfield_template_id: field.id,
        constraint: null,
        table_field_template_id: tableField.id,
        constant_value: null,
        related_subfield_template_id: null,
        pivot_field_template_id: null,
      },
    ])
  }

  const deleteRow = (id) => {
    setConstraints(constraints.filter((it) => it.id != id))
  }

  return (
    <Box>
      <Typography variant="p">Apply Table Constraints</Typography>
      <br />
      <Typography variant="p" style={{ fontSize: 14 }}>
        Value must be:
      </Typography>

      {constraints?.map((constraintItem) => {
        return (
          <TableFieldConstraintItemEditUI
            fields={fields}
            constraintItem={constraintItem}
            onDelete={deleteRow}
            selectedField={fields.find((it) => it.id == constraintItem.subfield_template_id)}
            pivotFields={pivotFields}
            updateConstraint={(updated) => {
              setConstraints(
                constraints.map((it) => {
                  return it.id == updated.id ? updated : it
                }),
              )
            }}
          />
        )
      })}
      <div
        style={{
          display: 'flex',
          columnGap: 16,
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 16,
        }}
      >
        <Button variant="contained" onClick={() => addRow()}>
          Add
        </Button>
        <Button color="primary" variant="contained" onClick={saveChanges}>
          Save Changes
        </Button>
      </div>
    </Box>
  )
}

export default TableFieldConstraintUI
